import { isColorLowContrast } from "./isColorLowContrast";

const getWhiteLabelDataAttributes = (hexaColor: string) => {
  const contrast = isColorLowContrast(hexaColor) ? "low" : "high";
  return { "data-color-contrast": contrast };
};
export { getWhiteLabelDataAttributes };
